



















































































import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import { mapGetters } from 'vuex'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import SellerInfoIcon from '~/components/car/classifieds/view/partials/seller/dealer/SellerInfoIcon.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { Seller } from '~/models/classified/types'
import VerifiedUser from '~/components/car/classifieds/view/partials/VerifiedUser.vue'
import { sellerIsBlacklistedAsSuspiciousOrFraudster } from '~/utils/user'
import { ciLocationPin } from '~/icons/source/solid/location-pin'
import CallButton from '~/components/car/classifieds/view/partials/call-button/CallButton.vue'

export default defineComponent({
  components: {
    CallButton,
    VerifiedUser,
    CAvatar,
    CHybridTelephone,
    SellerInfoIcon
  },
  props: {
    seller: {
      type: Object as PropType<Seller>,
      required: true
    }
  },
  computed: {
    sellerIsVerified(): Boolean {
      return this.seller?.verification?.creditCardVerified || false
    },
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster',
      sellerOnlyContactViaMessages: 'sellerOnlyContactViaMessages'
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    }),
    icons() {
      return {
        location: ciLocationPin
      }
    },
    sellerIsSuspiciousOrFraudster() {
      return sellerIsBlacklistedAsSuspiciousOrFraudster(this.seller)
    },
    userProfileUrl() {
      return this.seller.profile_url
    },
    avatarLink(): string {
      if (!this.sellerIsSuspiciousOrFraudster) {
        return this.userProfileUrl
      }
      return undefined
    },
    formattedInfo() {
      return {
        name: this.seller.name,
        address: this.seller.address,
        telephone1: this.seller.telephone1,
        telephone2: this.seller.telephone2,
        email: this.seller.email,
        contactViaMessages: this.sellerOnlyContactViaMessages
      }
    },
    isContactInfoVisible() {
      return (
        (!this.formattedInfo.contactViaMessages &&
          !this.sellerIsBlacklistedSuspiciousOrFraudster) ||
        this.isAdmin
      )
    }
  }
})
